export default {
  xs: {
    itemsPerRow: 1
  },
  sm: {
    itemsPerRow: 2,
    windowWidth: 768
  },
  md: {
    itemsPerRow: 3,
    windowWidth: 1024
  }
};
